const detail = {
  customerInfo: [
    {
      name: 'supplierName',
      text: 'order.order_supplier-name'
    },
    {
      name: 'abbreviation',
      text: 'product.product_vendor-name'
    },
    {
      name: 'description',
      text: 'product.product_auxiliary-explanation'
    },
    {
      name: 'address',
      text: 'common.address_address_0'
    },
    {
      name: 'contact',
      text: 'storage.storage_contact-address'
    },
    {
      name: 'section',
      text: 'order.order_department'
    },
    {
      name: 'rep',
      text: 'order.order_rep'
    },
    {
      name: 'desiredWarehousingLocation',
      text: 'order.order_desired-warehousing-location',
      component: 'SelectSuggestedReceivingLocation'
    },
    {
      name: 'paymentCriteria',
      text: 'common.input_payment-criteria'
    }
  ]
}

export default { detail }
